module.exports = __webpack_public_path__ + "static/media/visimisiimg.81d73386.png";